// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c2eeb222","977":"a36d707e"}[chunkId] + ".chunk.js";
};